import { message, PageHeader, Spin, Switch, Select, Checkbox, Divider, Tag, Alert, Table } from "antd";
import axios from "axios";
import React, {Component} from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import polizaPdf from "../../../../Pdf/polizaPdf";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  SelectItem,
  InputNumberItem,
  ButtonItem,
  ModalItem,
} from "../../../../Components/Items";
import SelectProveedoresItem from "../../../../Components/SelectProveedoresItem";
import ModalAjusteDiot from "../../../../Components/ModalAjusteDiot";
import moment from "moment";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;

const OPCIONES_DIOT_CLASIFICACION = [
  { value: "iva16Acreditable", label: "IVA 16% Acreditable" },
  { value: "iva16NoAcreditable", label: "IVA 16% No Acreditable" },
  { value: "iva8Acreditable", label: "IVA 8% Acreditable" },
  { value: "iva8NoAcreditable", label: "IVA 8% No Acreditable" },
  { value: "ivaRetenido", label: "IVA Retenido" },
];

class VerPoliza extends Component{
    diotFormRef = React.createRef();
    state = {
        loading: false,
        pdf: null,
        id: this.props.location.state.id,
        detallada: false,
        poliza: null,
        modalDiotVisible: false,
        diotParaDiot: false,
        loadingDiot: false,
        // Movimientos de la DIOT a los que corresponde esta poliza. Se resuelven por
        // Pago.polizaId / Pago.polizasId y NotaDeCreditoCompra.polizaId, no por
        // Poliza.facturaId, que esta sobrecargado y traeria movimientos ajenos.
        candidatosDiot: [],
        loadingCandidatos: false,
        modalAjusteVisible: false,
        candidatoSeleccionado: null,
      };

      atras() {
        this.props.history.push("/panel/polizas");
      }

      cargarPoliza(detallada) {
        this.setState({ loading: true });
        const body = { polizaId: this.state.id, empresaId: this.props.empresaId };
        if (detallada) body.detallada = true;
        axios
          .post("polizas/datosPoliza", body, { headers: this.props.headersToken })
          .then((res) => {
            if (res.data === "error") {
              message.error("Ha sucedido un error y no se cargo bien la poliza");
              this.setState({ loading: false });
            } else {
              const pdf = pdfMake.createPdf(polizaPdf(res.data));
              pdf.open({}, window.frames['printPdf']);
              this.setState({ loading: false, pdf, detallada: !!res.data.detallada, poliza: res.data });
            }
          });
      }

      componentDidMount() {
        this.cargarPoliza(false);
      }

      onCambiarDetallada(checked) {
        this.setState({ detallada: checked });
        this.cargarPoliza(checked);
      }

      abrirModalDiot() {
        const poliza = this.state.poliza || {};
        this.setState({ modalDiotVisible: true, diotParaDiot: !!poliza.paraDiot }, () => {
          this.diotFormRef.current?.setFieldsValue({
            paraDiot: !!poliza.paraDiot,
            diotProveedorId: poliza.diotProveedorId,
            diotClasificacion: poliza.diotClasificacion,
            diotBaseIva: poliza.diotBaseIva,
            diotIva: poliza.diotIva,
          });
        });
        this.cargarCandidatosDiot();
      }

      cargarCandidatosDiot() {
        this.setState({ loadingCandidatos: true });
        axios
          .post(
            "ajustesDiot/resolverMovimientoDiotPoliza",
            { polizaId: this.state.id, empresaId: this.props.empresaId },
            { headers: this.props.headersToken }
          )
          .then((res) => {
            this.setState({
              loadingCandidatos: false,
              candidatosDiot: res.data.success === 2 ? res.data.candidatos : [],
            });
          })
          .catch(() => this.setState({ loadingCandidatos: false, candidatosDiot: [] }));
      }

      cerrarModalAjuste(recargar) {
        this.setState({ modalAjusteVisible: false, candidatoSeleccionado: null });
        if (recargar) this.cargarCandidatosDiot();
      }

      guardarDiot(values) {
        this.setState({ loadingDiot: true });
        axios
          .post(
            "polizas/editarDiotPoliza",
            {
              polizaId: this.state.id,
              empresaId: this.props.empresaId,
              paraDiot: !!values.paraDiot,
              diotProveedorId: values.diotProveedorId,
              diotClasificacion: values.diotClasificacion,
              diotBaseIva: values.diotBaseIva,
              diotIva: values.diotIva,
            },
            { headers: this.props.headersToken }
          )
          .then((res) => {
            this.setState({ loadingDiot: false });
            if (res.data.success === 2) {
              message.success("DIOT de la poliza actualizado correctamente");
              this.setState({
                modalDiotVisible: false,
                poliza: { ...this.state.poliza, ...values },
              });
            } else {
              message.error("Ha ocurrido un error al guardar el DIOT de la poliza");
            }
          });
      }

      /**
       * Los dos modos de esta poliza frente a la DIOT son excluyentes por movimiento:
       * arriba se SUMA (marcar paraDiot, para IVA de importacion y pedimentos, que no
       * nacen de una factura) y aqui se SUSTITUYE lo que ya calculo el motor. Mezclarlos
       * sobre el mismo movimiento es justo lo que duplicaria el importe.
       */
      renderMovimientosDiot() {
        const candidatos = this.state.candidatosDiot || [];

        const columnas = [
          {
            title: "Movimiento", dataIndex: "descripcion", key: "descripcion", ellipsis: true,
            render: (valor, fila) => (
              <span style={{ color: fila.vigente ? undefined : "#bfbfbf" }}>
                {valor} {fila.tieneAjuste ? <Tag color="gold">Ajustado</Tag> : null}
                {fila.vigente ? null : <Tag>Cancelado</Tag>}
              </span>
            ),
          },
          {
            title: "Fecha", dataIndex: "fecha", key: "fecha", width: 105,
            render: (valor) => (valor ? moment(valor).format("DD/MM/YYYY") : "—"),
          },
          {
            title: "", key: "accion", width: 95,
            render: (valor, fila) => (fila.vigente ? (
              <ButtonItem
                blanco
                size="small"
                onClick={() => this.setState({
                  modalAjusteVisible: true,
                  candidatoSeleccionado: {
                    origen: fila.origen,
                    pagoId: fila.pagoId,
                    facturaId: fila.facturaId,
                    notaDeCreditoCompraId: fila.notaDeCreditoCompraId,
                    polizaId: fila.polizaId,
                  },
                })}
              >
                {fila.tieneAjuste ? "Editar" : "Ajustar"}
              </ButtonItem>
            ) : null),
          },
        ];

        return (
          <>
            <Divider orientation="left" style={{ fontSize: 13 }}>
              Movimiento de la DIOT relacionado
            </Divider>

            {this.state.loadingCandidatos ? (
              <div style={{ color: "#8c8c8c" }}>Buscando movimientos...</div>
            ) : candidatos.length === 0 ? (
              <Alert
                type="info"
                showIcon
                message="Esta poliza no genera por si sola ningun movimiento de la DIOT"
                description={
                  "Si es una poliza de IVA que debe declararse (importacion, pedimento, IVA retenido), " +
                  "marcala para DIOT arriba y captura su base e IVA: ese camino SUMA a la declaracion. " +
                  "La correccion de aqui abajo sirve para lo contrario, SUSTITUIR lo que el sistema ya calculo."
                }
              />
            ) : (
              <>
                <div style={{ marginBottom: 8, fontSize: 12, color: "#8c8c8c" }}>
                  Corregir aqui SUSTITUYE lo que el sistema calculo para ese movimiento; no se suma
                  encima, asi que el importe no se duplica.
                </div>
                <Table
                  size="small"
                  rowKey={(fila) => fila.claveMovimiento}
                  columns={columnas}
                  dataSource={candidatos}
                  pagination={false}
                />
              </>
            )}
          </>
        );
      }

    render(){
        return(
            <>
            <PageHeader
             onBack={this.atras.bind(this)}
              title="Ver Poliza"
              extra={[
                <span key="detallada" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span>Detallada</span>
                  <Switch
                    checked={this.state.detallada}
                    onChange={this.onCambiarDetallada.bind(this)}
                    loading={this.state.loading}
                  />
                </span>,
                this.props.permisoDiotPoliza && (
                  <ButtonItem
                    key="diot"
                    type="default"
                    onClick={this.abrirModalDiot.bind(this)}
                  >
                    DIOT
                  </ButtonItem>
                ),
              ]}
              style={{
                border: "1px solid rgb(235, 237, 240)",
                backgroundColor: "white",
                marginBottom: 10,
              }}
            />
            <div className="card-background" style={{ paddingTop: 5 }}>
                <Spin spinning={this.state.loading}>
                    <iframe title={'documentos'} style={{ width: '100%', height: '70vh' }} id="printPdf" name="printPdf"/>
                </Spin>
            </div>
            <ModalItem
              title="DIOT de esta Poliza"
              spinning={this.state.loadingDiot}
              visible={this.state.modalDiotVisible}
              onCancel={() => this.setState({ modalDiotVisible: false })}
            >
              <Form
                ref={this.diotFormRef}
                onFinish={this.guardarDiot.bind(this)}
              >
                <FormItem name="paraDiot" valuePropName="checked" margin>
                  <Checkbox
                    onChange={(e) => this.setState({ diotParaDiot: e.target.checked })}
                  >
                    Esta poliza corresponde a IVA para la Declaracion Informativa de
                    Operaciones con Terceros (DIOT)
                  </Checkbox>
                </FormItem>
                {this.state.diotParaDiot ? (
                  <>
                    <FormItem
                      label="Proveedor / Tercero (opcional)"
                      name="diotProveedorId"
                      margin
                    >
                      <SelectProveedoresItem
                        empresaId={this.props.empresaId}
                        headersToken={this.props.headersToken}
                        allowClear
                        width="100%"
                        placeholder="Proveedor / Tercero (opcional)"
                      />
                    </FormItem>
                    <FormItem
                      label="Clasificacion DIOT"
                      name="diotClasificacion"
                      required
                      margin
                    >
                      <SelectItem width="100%" placeholder="Clasificacion DIOT">
                        {OPCIONES_DIOT_CLASIFICACION.map((opcion) => (
                          <Option value={opcion.value} key={opcion.value}>
                            {opcion.label}
                          </Option>
                        ))}
                      </SelectItem>
                    </FormItem>
                    <FormItem
                      label="Base de IVA"
                      name="diotBaseIva"
                      number
                      required
                      margin
                    >
                      <InputNumberItem width="100%" dinero />
                    </FormItem>
                    <FormItem label="IVA" name="diotIva" number required margin>
                      <InputNumberItem width="100%" dinero />
                    </FormItem>
                  </>
                ) : null}
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  block
                  style={{ marginTop: 10 }}
                  loading={this.state.loadingDiot}
                >
                  Guardar
                </ButtonItem>
              </Form>

              {/* Fuera del Form a proposito: esta seccion no captura nada del formulario
                  de arriba (que marca la poliza para SUMAR a la DIOT) sino que abre la
                  correccion que SUSTITUYE. Son dos cosas distintas y mezclarlas en el
                  mismo submit invitaria a aplicar las dos al mismo movimiento. */}
              {this.renderMovimientosDiot()}
            </ModalItem>

            <ModalAjusteDiot
              visible={this.state.modalAjusteVisible}
              ancla={this.state.candidatoSeleccionado || {}}
              onCancel={() => this.cerrarModalAjuste(false)}
              onGuardado={() => this.cerrarModalAjuste(true)}
            />
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
      headersToken: state.user.headersToken,
      empresaId: state.empresa.id,
      permisoDiotPoliza: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cea8ff30e81b54183cfbf")?.activado,
    };
  };

export default connect(mapStateToProps)(VerPoliza);
